module.exports = __webpack_public_path__ + "static/media/logo-bll.a7ac7831.png";